import {IconButton as MuiIconButton, Box, Typography} from "@material-ui/core";
import {downloadImage} from "../../../../../../../../../../../utils/functions";
import {Download} from "react-feather";
import {Delete as DeleteIcon, Edit as EditIcon} from "@material-ui/icons";
import React, {FC} from "react";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {CheckboxGradient} from "../../../../../../../../../../components/CheckboxGradient";
import Image from "./Image";
import {AccessibilityImages} from "../../../../../../../../../../../models/AccessibilityImages";
import Swal from "sweetalert2";

const IconButton = styled(MuiIconButton)`
  color: #78909C
`

type IndexProps = {
  color?: string
}

const Index = styled.div<IndexProps>`
  position: absolute;
  bottom: 3px;
  left: 10px;
  font-size: 38px;
  transition: color 0.3s ease;
  text-shadow: 0px 0px 2px #55555547;
  color: ${(props) => props.color ? props.color : 'rgba(132, 250, 176, 1)'};
`

type PropsType = {
  item: AccessibilityImages;
  index: number;
  onSetEditorMode: (data: AccessibilityImages) => void
  onSetCheckbox: (data: AccessibilityImages) => void
  onDeleteImage: (data: AccessibilityImages) => void
}
const ImageItem: FC<PropsType> = ({ item, index, onSetEditorMode, onSetCheckbox, onDeleteImage }) => {
  const { t } = useTranslation()

  const handleIdDisplay = (state: boolean) => {
    onSetCheckbox({
      ...item,
      is_display_in_output_service: state
    })
  }

  const handleDeleteImage = () => {
    Swal.fire({
      title: t('imagesPage_Are_your_sure'),
      text: `${t('imagesPage_Delete')} '${item.description}'?`,
      confirmButtonText: t('imagesPage_Yes'),
      cancelButtonText: t('imagesPage_Cancel'),
      showCancelButton: true,
      reverseButtons: true,
      width: '400px'
    }).then((result) => {
      if (result.isConfirmed) {
        onDeleteImage(item)
      }
    })
  }

  return (
    <React.Fragment>
      <Box
        p={4}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        style={{
          cursor: 'grab',
        }}
      >
        <div style={{position: 'relative'}}>
          <Index color={item.is_display_in_output_service ? 'rgba(132, 250, 176, 1)' : '#e3e3e3'}>{index + 1}</Index>
          <CheckboxGradient
            customSize={50}
            style={{ position:"absolute", right: 0, bottom: 0}}
            checked={item.is_display_in_output_service}
            onChange={(e) => handleIdDisplay(e.target.checked)}
          />
          <Image
            active={item.is_display_in_output_service}
            alt={item.description}
            src={item.thumbnails.small}
          />
        </div>
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          my={3}
        >
          <IconButton
            title={t('generalWords_Download')}
            aria-label={t('generalWords_Download')}
            color="inherit"
            onClick={() => downloadImage(item.image)}
          >
            <Download />
          </IconButton>
          <IconButton
            title={t('imagesPage_Edit')}
            aria-label={t('imagesPage_Edit')}
            onClick={() => onSetEditorMode(item)}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            onClick={handleDeleteImage}
            title={t('imagesPage_Delete_image')}
            aria-label={t('imagesPage_Delete_image')}>
            <DeleteIcon />
          </IconButton>
        </Box>
        <Typography
          style={{
            color: 'rgba(203, 205, 209, 1)',
            maxWidth: 200
          }}
          align={'center'}
        >
          {item.description}
        </Typography>
      </Box>
    </React.Fragment>
  )
}

export default ImageItem